import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import FlightHelper from 'components/common/helpers/FlightHelper';
import airplane_icon_negative from 'components/assets/img/icons/airplane-negative.svg';
import ReservationUpdateHelper from '../utils/ReservationUpdateHelper';
import withRouter from 'components/components/common/withRouter';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';


class SummaryContent extends Component {

  trans = (key) => {
    return TransHelper.translate(this.props.locale, 'content.dashboard.summary.' + key);
  }

  getHelper = () => {
    const { reservationUpdate, reservation } = this.props;
    return new ReservationUpdateHelper(reservation, reservationUpdate);
  }

  getMiddleLabel = () => {
    var helper = this.getHelper();
    if (helper.isOnlinePayment()) {
      return this.trans('newPrice');
    } else {
      return this.trans('changePrice');
    }
  }

  getMiddlePrice = () => {
    const { reservationUpdate } = this.props;
    var helper = this.getHelper();
    if (helper.isOnlinePayment()) {
      return reservationUpdate.price;
    } else {
      return helper.differenceLabel();
    }
  }

  getLastLabel = () => {
    var helper = this.getHelper();
    if (helper.isOnlinePayment()) {
      if (helper.differencePrice() > 0) {
        return this.trans('paySupl');
      } else {
        return this.trans('refund');
      }
    } else {
      return this.trans('newPrice');
    }
  }

  getLastPrice = () => {
    const { reservationUpdate } = this.props;
    var helper = this.getHelper();
    if (helper.isOnlinePayment()) {
      return helper.differenceLabel();
    } else {
      return reservationUpdate.price ? reservationUpdate.price : '--';
    }
  }

  handleClickOk = (e) => {
    e.preventDefault();
    TransHelper.redirect(this.props, 'routes.url.dashboard');
  }

  render() {
    const { reservationUpdate, reservation, locale } = this.props;
    var helper = new ReservationUpdateHelper(reservation, reservationUpdate);
    var flightHelper = new FlightHelper(
      reservation.flight,
      locale,
      reservation.reservation_direction
    );
    return (
      <div
        className={classNames(
          'content__desc',
          'dashboard-summary',
          'dashboard-summary--negative'
        )}
        style={{ padding: 0 }}>

        <div className="dashboard-edit-summary">
          {!helper.haveToPayExtra() && (
            <h3>
              <T>content.dashboard.summary.changesSaved</T>
            </h3>
          )}

          <ul className="list-summary list-summary--cell">
            <li className="list-summary__item">
              <div className="list-summary__header">
                <div className="text-bold">{flightHelper.getLabel()}</div>
                <div>{flightHelper.getFlightDate()}</div>
              </div>
              <div className="list-summary__desc">
                <div>{flightHelper.getFrom()}</div>
                <div><img src={airplane_icon_negative} alt="icone airplane" /></div>
                <div>{flightHelper.getTo()}</div>
                <div className="list-flights__time">{flightHelper.getFlightTimeTo()}</div>
              </div>
            </li>
          </ul>

          <div className="content__desc">
            <table className="list-order">
              <tbody>
                <tr>
                  <td className="list-order__label">
                    <T>content.dashboard.summary.oldPrice</T>
                  </td>
                  <td className="list-order__price">
                    {parseFloat(reservation.price)} <span className="currency"><T>content.common.currency</T></span>
                  </td>
                </tr>

                <tr className="list-order__new-price">
                  <td className="list-order__label">
                    {this.getMiddleLabel()}
                  </td>
                  <td className="list-order__price list-order__price--new">
                    {this.getMiddlePrice()} <span className="currency"><T>content.common.currency</T></span>
                  </td>
                </tr>

                <tr>
                  <td className="list-order__label list-order__label--big">
                    {this.getLastLabel()}
                  </td>
                  <td className="list-order__price list-order__price--big">
                    {this.getLastPrice()} <span className="currency"><T>content.common.currency</T></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {!helper.haveToPayExtra() && (
            <Fragment>
              {reservation.payment_to_driver && (
                <p className="text-center text-small text-italic mb-45">
                  <T>content.dashboard.summary.payDriver</T>
                </p>
              )}

              <button
                className="button button--outline button--invert button--expand"
                onClick={this.handleClickOk}
              >
                <T>content.dashboard.summary.buttonText</T>
              </button>
            </Fragment>
          )}

        </div>
      </div>
    );
  }
}

export default withRouter(SummaryContent);